import { RemoteGetLastProductVersions } from 'data/usecases/common-utils/get-last-product-versions';
import { GetLastProductVersionsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlLastProductVersions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetLastProductVersions =
  (): GetLastProductVersionsUseCaseInterface => {
    return new RemoteGetLastProductVersions(
      makeApiUrlLastProductVersions(),
      makeAxiosHttpClient(),
    );
  };
